module.exports = __webpack_public_path__ + "assets/img/1111587020848_.pic_hd.42345e7e.jpg";